import { useEffect } from 'react';

import { useAuth } from '@/_shared/hooks/useAuth';
import { identifyUser, resetAnalytics } from '@/_shared/lib/analytics';

/** Sync RudderStack identify with auth state. */
export function AnalyticsIdentity(): null {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      identifyUser(user.id, { email: user.email, displayName: user.displayName });
    } else {
      resetAnalytics();
    }
    // Deliberately depend on primitives, not the `user` object reference: auth queries can refetch
    // with a new object reference for the same account, and identifying on every referential change
    // (rather than an actual field change) would double-fire the analytics identify call. Covered by
    // the "does not re-identify ... new object reference but same primitives" test in
    // AnalyticsIdentity.test.tsx.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- see comment above: primitives are intentional, not a missing `user` dep
  }, [user?.id, user?.email, user?.displayName]);

  return null;
}
